import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-index-head",
  inject: ["setPopHowWorksShow"],
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onHowWorksShow() {
      this.setPopHowWorksShow(true);
    }
  }
};